import {
    important,
    rem,
    size,
    smallScreen
} from '-/styles/utils';

export default theme => ({
    root: {
        marginBottom: rem(theme.greetingSpacing),
        padding: `0 ${rem(16)}`,
        color: theme.colors.greeting,
        textAlign: 'center'
    },
    notMe: {
        color: 'black !important'
    },
    hr: {
        ...size('30%', '3px'),
        borderRadius: '12px',
        margin: `0 auto ${rem(18)}`,
        border: 'none'
    },
    p: {
        marginBottom: important(rem(theme.greetingSpacing)),
        fontSize: important(rem(20)),
        fontWeight: 'normal',
        textAlign: 'center',
        lineHeight: important(rem(23)),
        ...smallScreen({
            lineHeight: important(rem(20)),
            marginBottom: important(rem(20))
        }),
        '& b': {
            fontWeight: 'normal',
            fontSize: rem(24)
        },
        '&:last-child': {
            marginBottom: '0'
        }
    },
    ul: {
        marginBottom: rem(theme.greetingSpacing),
        minWidth: rem(300)
    },
    li: {
        textAlign: 'left',
        lineHeight: rem(23),
        paddingLeft: rem(15),
        marginLeft: rem(15)
    }
});
